import React, { useState } from 'react';
import { Box, ButtonGroup, Button } from '@mui/material';
import RenderFields from '../Renders/RenderFields';

const InspectionsCard = ({ assignedInspections, inspectionFields, selectedInspection, setSelectedInspection, isEditMode, updateInspection, handleChange }) => {
  const [editableInspection, setEditableInspection] = useState(null);

  const handleInspectionClick = (inspection) => {
    setSelectedInspection(inspection);
    setEditableInspection(inspection);
  };

  const handleFieldChange = (e) => {
    handleChange(e, editableInspection, setEditableInspection);
  };

  const handleUpdate = () => {
    if (editableInspection) {
      updateInspection(editableInspection);
    }
  };

  return (
    <Box mb={2}>
      <h3 className="text-xl font-bold mb-2">Inspections</h3>
      {assignedInspections.length > 0 ? (
        <Box className="flex mb-4">
          <ButtonGroup orientation="vertical">
            {assignedInspections.map((inspection) => (
              <Button
                key={inspection.inspectionId}
                onClick={() => handleInspectionClick(inspection)}
                variant={selectedInspection?.inspectionId === inspection.inspectionId ? 'contained' : 'outlined'}
              >
                {inspection.inspectionId}
              </Button>
            ))}
          </ButtonGroup>
          <Box ml={4}>
            {selectedInspection ? (
              <RenderFields 
                fields={inspectionFields} 
                formData={editableInspection} 
                handleChange={isEditMode ? handleFieldChange : undefined} 
                readOnly={!isEditMode} 
              />
            ) : (
              <p>Select an inspection to view details.</p>
            )}
          </Box>
        </Box>
      ) : (
        <p>No inspections assigned to this building.</p>
      )}
      {isEditMode && editableInspection && (
        <Button variant="contained" color="primary" onClick={handleUpdate}>
          Submit Changes
        </Button>
      )}
    </Box>
  );
};

export default InspectionsCard;
